module.exports = {
	"config": {
		"siteTitle": "Our Gatsby Blog by Flamelily",
		"siteDescr": "This is a static blog site created with Gatsby.",
		"siteAuthor": "Flamelily IT",
		"siteTelegramUrl": "#",
		"siteTwitterUrl": "https://twitter.com/flamelilyit",
		"siteGithubUrl": "https://github.com/flamelily",
		"siteEmailUrl": "mailto:info@flamelily.co.uk",
		"siteRssUrl": "#",
		"siteVkUrl": "#",
		"googleAnalyticsId": "",
		"linkPrefix": "/gatsby-lumen"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/opt/build/repo/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/opt/build/repo/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2015-05-01-hello-world",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2015-05-01-hello-world",
				"stem": "index",
				"path": "articles/2015-05-01-hello-world/index.md",
				"absolute": "/opt/build/repo/articles/2015-05-01-hello-world/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2015-05-01-hello-world/index.md",
			"path": "/hello-world/",
			"data": {
				"title": "The Birth of Movable Type",
				"date": "2016-03-01T22:12:03.284Z",
				"layout": "post",
				"path": "/hello-world/",
				"category": "Typography TESTS",
				"description": "German inventor Johannes Gutenberg developed a method of movable type and used it to create one of the western world’s first major printed books, the “Forty–Two–Line” Bible."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2015-05-06-my-second-post",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2015-05-06-my-second-post",
				"stem": "index",
				"path": "articles/2015-05-06-my-second-post/index.md",
				"absolute": "/opt/build/repo/articles/2015-05-06-my-second-post/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2015-05-06-my-second-post/index.md",
			"path": "/my-second-post/",
			"data": {
				"title": "My Second Post!",
				"date": "2015-05-06T23:46:37.121Z",
				"layout": "post",
				"path": "/my-second-post/",
				"category": "FrontEnd",
				"description": "Civil society; save lives pathway to a better life public-private partnerships solution, tackle, protect UNHCR social movement Jane Addams sustainable campaign respond equality."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2015-05-28-hi-folks",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2015-05-28-hi-folks",
				"stem": "index",
				"path": "articles/2015-05-28-hi-folks/index.md",
				"absolute": "/opt/build/repo/articles/2015-05-28-hi-folks/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2015-05-28-hi-folks/index.md",
			"path": "/hi-folks/",
			"data": {
				"title": "New Beginnings",
				"date": "2015-05-28T22:40:32.169Z",
				"layout": "post",
				"path": "/hi-folks/",
				"category": "FrontEnd",
				"description": "Employment, gender, breakthrough insights carbon emissions reductions peaceful, sharing economy Angelina Jolie accelerate, inclusive capitalism research inspire social change social good informal economies minority. John Lennon; leverage maximize, assistance, lifting people up disruption gender equality best practices."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-05-29-the-humble-floppy-disk",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-05-29-the-humble-floppy-disk",
				"stem": "index",
				"path": "articles/2016-05-29-the-humble-floppy-disk/index.md",
				"absolute": "/opt/build/repo/articles/2016-05-29-the-humble-floppy-disk/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2016-05-29-the-humble-floppy-disk/index.md",
			"path": "/the-humble-floppy-disk/",
			"data": {
				"layout": "post",
				"path": "/the-humble-floppy-disk/",
				"img": null,
				"link": null,
				"caption": null,
				"category": "Nostalgia",
				"tags": "floppy,disk,old,ancient, autoexec.bat,config.sys",
				"permalink": "/:year/:month/:title/",
				"title": "The humble floppy disk",
				"description": "Connected my USB floppy drive to Fedora the other day and my 10 year old daughter peers over my shoulder.",
				"excerpt_separator": "<!--more-->"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx",
				"absolute": "/opt/build/repo/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages/about/index.md",
				"absolute": "/opt/build/repo/pages/about/index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "About me",
				"layout": "page",
				"path": "/about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/contact",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/contact",
				"stem": "index",
				"path": "pages/contact/index.md",
				"absolute": "/opt/build/repo/pages/contact/index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/contact/index.md",
			"path": "/contact/",
			"data": {
				"title": "Contact me",
				"layout": "page",
				"path": "/contact"
			}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 374
 ** module chunks = 0
 **/